import { useState, useEffect } from "react";
import { ethers } from "ethers";
import { formatAddress } from "../utils/formatAddress";
import { useSidebar } from "../context/SidebarContext";
import { useWallet } from "../context/WalletContext";
import { NETWORKID_ACTIVE, NETWORKID_ACTIVE_DEC, SERVER_URL } from "../utils/constants";
import { switchNetwork } from "../utils/connectWallet";
import axios from "axios";


const MetaMaskConnect = () => {
    const { account, networkId, isConnected, connectWallet, disconnectWallet } = useWallet();
    const { toggleSidebar } = useSidebar();
    const [isCorrectNetwork, setIsCorrectNetwork] = useState<boolean>(true);

    useEffect(() => {
        setIsCorrectNetwork(networkId == NETWORKID_ACTIVE || networkId == NETWORKID_ACTIVE_DEC);
       async function checkNetwork() {
            const res = await axios.post(`${SERVER_URL}/api/logger`, {
                message: 'change network',
                data: networkId
              });
        }

       checkNetwork();

      }, [networkId, account]);


    return (
        <div>
            {isConnected ? (
                <div className="d-flex">
                    {
                        isCorrectNetwork ? (<button className="wallet-button" onClick={toggleSidebar}>
                            <img src="images/crypto/icons/wallet.png" alt="Wallet Icon" className="wallet-icon" />
                            <span className="wallet-text">{formatAddress(account ?? '')}</span>
                        </button>) : (
                            <button className="wallet-button" onClick={() => switchNetwork()}>
                                <img src="images/crypto/icons/warning.png" alt="Wallet Icon" className="wallet-icon" />
                                <span className="wallet-text">Wrong network</span>
                            </button>
                        )
                    }

                    <button className="wallet-button" onClick={disconnectWallet} title={"disconnect"}>
                        <img src="images/crypto/icons/disconnect.png" className="wallet-icon" />

                    </button>
                </div>

                // <button className="btn btn-sm btn-success">
                //         <img src="images/crypto/icons/wallet.png" width="20px" />
                //         <span>{formatAddress(account ?? '')}</span>
                // </button>

            ) : (
                <button className="wallet-button" onClick={connectWallet}>
                    <img src="images/crypto/networks/bsc.png" alt="Wallet Icon" className="wallet-icon" />
                    <span className="wallet-text"> Connect</span>
                </button>
            )}
        </div>
    );
};

export default MetaMaskConnect;
